import NewsCard from "../UI/block/card/NewsCard";
import { formatDate } from '../../helpers/Date';

import './NewsShowcase.sass';

const NewsShowcase = ({newsInfo}) => {
    return (
        <div className="news-showcase">
            {newsInfo.map((news, index) => (
                <NewsCard
                    key={index}
                    banner={news.banner}
                    author={news.author_name}
                    title={news.title}
                    date={formatDate(news.date)}
                    hashtags={news.hashtags}
                    slug={news.slug}
                />
            ))}
        </div>
    );
};

export default NewsShowcase;